import { EditorContextService } from '@magnolia/frontend-helpers-base';

function assertBrowserOnly() {
    if (typeof window === 'undefined') {
        throw new Error('magnolia-service must run in a browser environment');
    }
}

function buildSafeUrl(base, path, search = '') {
    const url = new URL(base);

    const safePath = String(path || '')
        .split('/')
        .map((seg) => encodeURIComponent(seg))
        .join('/');

    url.pathname = [url.pathname.replace(/\/+$/, ''), safePath.replace(/^\/+/, '')].filter(Boolean).join('/');

    if (search) {
        const s = String(search);
        url.search = s.startsWith('?') ? s : `?${s}`;
    }

    return url;
}

export async function fetchPageContent(magnoliaContext, pageBase) {
    assertBrowserOnly();
    const url = buildSafeUrl(pageBase, magnoliaContext.nodePath, magnoliaContext.search);
    const pagesRes = await fetch(url);
    return await pagesRes.json();
}

export async function fetchTemplateAnnotations(magnoliaContext, templateAnnotationsBase) {
    assertBrowserOnly();
    if (magnoliaContext.isMagnolia) {
        const url = buildSafeUrl(templateAnnotationsBase, magnoliaContext.nodePath, magnoliaContext.search);
        const templateAnnotationsRes = await fetch(url);
        return await templateAnnotationsRes.json();
    }
}

export function getMgnlContext(mgnlContentPath, appBase, languages, language) {
    // Canonical appBase: either "" or "/migrosbank/eb-campaigns" (no trailing slash)
    const safeAppBase = `/${(appBase ?? '').trim().replace(/^\/+|\/+$/g, '')}`.replace(/^\/$/, '');

    let contentPath = String(mgnlContentPath ?? '').trim();
    if (!contentPath.startsWith('/')) contentPath = `/${contentPath}`;

    // If contentPath already includes appBase as a proper path prefix, strip it once.
    if (safeAppBase && (contentPath === safeAppBase || contentPath.startsWith(`${safeAppBase}/`))) {
        contentPath = contentPath.slice(safeAppBase.length) || '/';
        if (!contentPath.startsWith('/')) contentPath = `/${contentPath}`;
    }

    // need to prepend language in order to make magnolia recognize / enforce the desired language
    const localizedPath = (language ? `/${language}${contentPath}/` : `${contentPath}/`).replaceAll('//', '/');

    // Pass appBase separately (Magnolia will mount the context under this base)
    const ctx = EditorContextService.getMagnoliaContext(localizedPath, safeAppBase || '/', languages);
    ctx.nodePath = ctx.nodePath.replaceAll('//', '/');
    return ctx;
}
